<template>
  <div class="bank-container">
    <div class="bank-card">
      <!-- 标题 -->
      <div class="bank-header">
        <span class="bank-title">{{ $t('_m._yhxx') }}</span>
      </div>

      <!-- 银行信息 -->
      <div class="info-section">
        <div class="info-item" v-if="bankList.bank_name">
          <span class="info-label">{{ $t('_m._yhmz') }}</span>
          <span class="info-divider">:</span>
          <div class="info-value-wrap">
            <span class="info-value">{{ bankList.bank_name }}</span>
            <button class="copy-btn" @click="onCopy(bankList.bank_name)">
              <CopyOutlined />
            </button>
          </div>
        </div>

        <div class="info-item" v-if="bankList.bank_address">
          <span class="info-label">{{ $t('_m._yhdz') }}</span>
          <span class="info-divider">:</span>
          <div class="info-value-wrap">
            <span class="info-value">{{ bankList.bank_address }}</span>
            <button class="copy-btn" @click="onCopy(bankList.bank_address)">
              <CopyOutlined />
            </button>
          </div>
        </div>

        <div class="info-item" v-if="bankList.name">
          <span class="info-label">{{ $t('_m._yhmc') }}</span>
          <span class="info-divider">:</span>
          <div class="info-value-wrap">
            <span class="info-value">{{ bankList.name }}</span>
            <button class="copy-btn" @click="onCopy(bankList.name)">
              <CopyOutlined />
            </button>
          </div>
        </div>

        <div class="info-item" v-if="bankList.account">
          <span class="info-label">{{ $t('_m._yhzh') }}</span>
          <span class="info-divider">:</span>
          <div class="info-value-wrap">
            <span class="info-value">{{ bankList.account }}</span>
            <button class="copy-btn" @click="onCopy(bankList.account)">
              <CopyOutlined />
            </button>
          </div>
        </div>

        <div class="info-item" v-if="bankList.routing">
          <span class="info-label">{{ $t('_m._yhly') }}</span>
          <span class="info-divider">:</span>
          <div class="info-value-wrap">
            <span class="info-value">{{ bankList.routing }}</span>
            <button class="copy-btn" @click="onCopy(bankList.routing)">
              <CopyOutlined />
            </button>
          </div>
        </div>

        <div class="info-item" v-if="bankList.code">
          <span class="info-label">{{ $t('_m._yhdm') }}</span>
          <span class="info-divider">:</span>
          <div class="info-value-wrap">
            <span class="info-value">{{ bankList.code }}</span>
            <button class="copy-btn" @click="onCopy(bankList.code)">
              <CopyOutlined />
            </button>
          </div>
        </div>

        <div class="info-item">
          <span class="info-label">{{ $t('_m._yhbz') }}</span>
          <span class="info-divider">:</span>
          <div class="info-value-wrap">
            <span class="info-value">{{ userInfo?.uid || '' }}</span>
            <button class="copy-btn" @click="onCopy(userInfo?.uid || '')">
              <CopyOutlined />
            </button>
          </div>
        </div>
      </div>

      <!-- 注意事项 -->
      <div class="tips-section">
        <div class="tips-title">{{ $t('_m._zts') }}</div>
        <ul class="tips-list">
          <li>{{ $t('_m._zyd1') }}</li>
          <li>{{ $t('_m._zyd2') }}</li>
          <li>{{ $t('_m._zyd3') }}</li>
          <li>{{ $t('_m._zyd4') }}</li>
        </ul>
      </div>

      <!-- 操作按钮 -->
      <div class="action-buttons">
        <button class="btn-back" @click="onBack">
          <i class="fas fa-arrow-left"></i>
          {{ $t('_sp._fanh') }}
        </button>
        <button class="btn-copy-all" @click="onCopyInfo">
          <i class="fas fa-copy"></i>
          {{ $t('_m._fzxx') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { CopyOutlined } from '@ant-design/icons-vue'

export default {
  name: 'BankTransferVue',
  components: { CopyOutlined },
  data() {
    return {
      bankList: {},
      userInfo: {}
    }
  },
  created() {
    this.userInfo = this.$common.getInfo() || {}
    this.getBankList()
  },
  methods: {
    getBankList() {
      this.$api.bank.getBankList().then((res) => {
        this.bankList = res.data || {}
      })
    },

    onBack() {
      this.$router.push({ name: 'wallet' })
    },

    onCopy(token) {
      if (!token) return
      navigator.clipboard
        .writeText(String(token))
        .then(() => {
          this.$message.success(this.$t('_m._fzcg'))
        })
        .catch(() => {
          this.$message.error(this.$t('_m._fzsb'))
        })
    },

    onCopyInfo() {
      const fields = [
        this.bankList.bank_name,
        this.bankList.bank_address,
        this.bankList.name,
        this.bankList.account,
        this.bankList.routing,
        this.bankList.code,
        this.userInfo?.uid
      ]

      const info = fields.filter(Boolean).join('\n')

      if (!info) {
        this.$message.warning(this.$t('_m._zwfzxx'))
        return
      }

      navigator.clipboard
        .writeText(info)
        .then(() => {
          this.$message.success(this.$t('_m._fzcg'))
        })
        .catch(() => {
          this.$message.error(this.$t('_m._fzsb'))
        })
    }
  }
}
</script>

<style scoped>
/* ============================================================
   银行转账 - 深灰主题
   ============================================================ */

.bank-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0;
}

.bank-card {
  max-width: 720px;
  margin: 0 auto;
  background: #1a1f26;
  border-radius: 16px;
  border: 1px solid #2a3038;
  padding: 28px 32px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

/* ============================================================
   标题
   ============================================================ */
.bank-header {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #2a3038;
}

.bank-title {
  font-size: 20px;
  font-weight: 700;
  color: #e8edf2;
}

/* ============================================================
   信息列表
   ============================================================ */
.info-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: #0f1419;
  border-radius: 8px;
  border: 1px solid #2a3038;
  transition: border-color 0.3s;
}

.info-item:hover {
  border-color: #3a4652;
}

.info-label {
  font-size: 14px;
  font-weight: 500;
  color: #6a7a8a;
  flex-shrink: 0;
}

.info-divider {
  color: #3a4652;
  flex-shrink: 0;
}

.info-value-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.info-value {
  font-size: 14px;
  color: #e8edf2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}

.copy-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #6a7a8a;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.copy-btn:hover {
  color: #ffb300;
  background: rgba(255, 179, 0, 0.08);
}

.copy-btn:active {
  transform: scale(0.9);
}

/* ============================================================
   注意事项
   ============================================================ */
.tips-section {
  background: #0f1419;
  border-radius: 10px;
  border: 1px solid #2a3038;
  padding: 16px 18px;
  margin-bottom: 20px;
}

.tips-title {
  font-size: 15px;
  font-weight: 600;
  color: #e8edf2;
  margin-bottom: 8px;
}

.tips-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.tips-list li {
  font-size: 13px;
  color: #8a949f;
  line-height: 1.6;
  padding-left: 16px;
  position: relative;
}

.tips-list li::before {
  content: '•';
  position: absolute;
  left: 0;
  color: #ffb300;
  font-weight: 700;
}

/* ============================================================
   操作按钮
   ============================================================ */
.action-buttons {
  display: flex;
  gap: 12px;
}

.btn-back {
  flex: 0 0 auto;
  padding: 12px 24px;
  border: 1px solid #2a3038;
  border-radius: 10px;
  background: transparent;
  color: #8a949f;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-back:hover {
  background: rgba(255, 255, 255, 0.04);
  border-color: #3a4652;
  color: #e8edf2;
}

.btn-copy-all {
  flex: 1;
  padding: 12px 20px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, #ffb300, #f57c00);
  color: #0b0d0f;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-copy-all:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(255, 179, 0, 0.3);
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 640px) {
  .bank-card {
    padding: 20px 18px 18px;
    border-radius: 12px;
  }

  .bank-title {
    font-size: 17px;
  }

  .info-item {
    padding: 8px 12px;
    flex-wrap: wrap;
    gap: 4px 8px;
  }

  .info-label {
    font-size: 13px;
  }

  .info-value {
    font-size: 13px;
  }

  .tips-section {
    padding: 12px 14px;
  }

  .tips-list li {
    font-size: 12px;
  }

  .action-buttons {
    flex-direction: column;
  }

  .btn-back {
    flex: 1;
    padding: 10px 16px;
    font-size: 14px;
  }

  .btn-copy-all {
    padding: 10px 16px;
    font-size: 14px;
  }
}

@media (max-width: 400px) {
  .bank-card {
    padding: 16px 12px 14px;
  }

  .bank-title {
    font-size: 15px;
  }

  .info-item {
    padding: 6px 10px;
    flex-direction: column;
    align-items: stretch;
    gap: 2px;
  }

  .info-label {
    font-size: 12px;
  }

  .info-divider {
    display: none;
  }

  .info-value {
    font-size: 12px;
  }

  .copy-btn {
    width: 26px;
    height: 26px;
  }

  .tips-title {
    font-size: 14px;
  }

  .btn-back,
  .btn-copy-all {
    font-size: 13px;
    padding: 8px 14px;
  }
}
</style>